import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';
import ReactModal from 'react-modal';

export default class RoomsPage extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      deleteRoomIndex: 0,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModalYes = this.handleModalYes.bind(this);
    this.handleModalNo = this.handleModalNo.bind(this);
  }
  formatNumber = val => val.toString(10).replace(/[.]/g, ',');
  handleOpenModal(index) {
    this.setState({ showModal: true, deleteRoomIndex: index });
  }
  handleModalYes() {
    this.setState({ showModal: false });
    this.props.removeRoom(this.state.deleteRoomIndex);
  }
  handleModalNo() {
    this.setState({ showModal: false });
  }
  style = {};

  render = () => (
    <div className="content">
      <div>
        <RothButton type="back" fn={this.props.changePage} param={this.props.backPage} value={this.props.backSubPage}>
          {'← ' + this.props.text('other', 'back')}
        </RothButton>
        <div className="inner">
          <h1>{this.props.text('rooms', 'h1')}</h1>
          <p>{this.props.text('rooms', 'desc')}</p>
          <p style={this.props.oneRoomOnly ? { marginTop: '10px' } : { display: 'none' }}>{this.props.text('rooms', 'oneRoomOnly')}</p>
          <div>
            {this.props.rooms.map((room, index) => (
              <div key={index} className="roomButton" style={{ display: 'inline-block', padding: '20px 25px 0px 0px' }}>
                <table style={{ width: '100%' }}>
                  <tbody>
                    <tr>
                      <td style={{ width: '38px', textAlign: 'center' }}>
                        <RothButton
                          type="text"
                          style={{
                            color: this.props.constants.colorRed,
                            marginTop: 'auto',
                            marginBottom: 'auto',
                            marginLeft: '0px',
                            marginRight: '0px',
                            display: this.props.oneRoomOnly ? 'none' : 'inline-block',
                          }}
                          fn={this.handleOpenModal}
                          value={index}
                        >
                          &nbsp;&nbsp;X
                        </RothButton>
                      </td>
                      <td>
                        <span style={{ display: 'inline-block', marginRight: 'auto' }}>
                          <span style={{ color: room.area === 0 ? this.props.constants.colorRed : this.props.constants.colorBlack }}>
                            {room.name}, {this.formatNumber(room.area)}&nbsp;m²
                          </span>
                          <br />
                          {this.props.text('room', 'system_' + room.floorType + '_' + room.system)}, <br />
                          {this.props.text('room', 'pipeDimension_' + room.pipeDimension)}
                        </span>
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        <RothButton
                          fn={this.props.changePage}
                          param="room"
                          value={index}
                          style={{ display: 'inline-block', margin: '0px' }}
                        >
                          {this.props.text('rooms', 'edit')}
                        </RothButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
            <ReactModal
              isOpen={this.state.showModal}
              contentLabel=""
              style={{
                content: {
                  position: 'absolute',
                  top: '30%',
                  width: 'calc(100% - 80px)',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  height: '300px',
                  border: '0px solid white',
                  backgroundColor: this.props.constants.colorRed,
                  borderRadius: '22px',
                  padding: '40px 10px',
                  maxWidth: '500px',
                },
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                <div style={{ textAlign: 'center', color: 'white', fontSize: '30px', whiteSpace: 'pre-wrap' }}>
                  {this.props
                    .text('rooms', 'removePrompt')
                    .split('\n')
                    .map((item, i) => (
                      <span key={i}>
                        {item}
                        <br />
                      </span>
                    ))}
                  {this.state.deleteRoomIndex in this.props.rooms ? this.props.rooms[this.state.deleteRoomIndex].name : ''}?
                </div>
                <div style={{ textAlign: 'center' }}>
                  <RothButton type="halfWhite" fn={this.handleModalYes}>
                    {this.props.text('rooms', 'yes')}
                  </RothButton>
                  <RothButton type="halfWhite" fn={this.handleModalNo}>
                    {this.props.text('rooms', 'no')}
                  </RothButton>
                </div>
              </div>
            </ReactModal>
          </div>
        </div>
      </div>
      <div style={{ textAlign: 'center' }}>
        <RothButton disabled={!this.props.isPageAllowed('disclaimer')} type="half" fn={this.props.changePage} param={'disclaimer'}>
          {this.props.text('rooms', 'done')}
        </RothButton>
        <RothButton style={this.props.oneRoomOnly ? { display: 'none' } : {}} type="half" fn={this.props.addRoom}>
          {this.props.text('rooms', 'addRoom')}
        </RothButton>
      </div>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/RoomsPage.js
 **/